import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ValidateUserWithPasswordRequestModel, ValidateUserWithPersonalInformationRequestModel, ValidateUserResponseModel, RequiredInformationModel, LogoutUserRequestModel, LogoutUserResponseModel } from '../../model/models';
import { HttpClient, HttpBackend, HttpParams } from '@angular/common/http';
import { StorageService } from '../../shared/security/StorageService';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../shared/security/AuthenticationService';


@Injectable()
export class LoginService {

    public notifySearchUserInformation: EventEmitter<ValidateUserResponseModel> = new EventEmitter<ValidateUserResponseModel>();
    public notifyRequiredUserInformation : EventEmitter<RequiredInformationModel> = new EventEmitter<RequiredInformationModel>();
    onLogin: EventEmitter<any> = new EventEmitter<any>();
    onLoginFail : EventEmitter<any> = new EventEmitter<any>();
    private http : HttpClient;

    constructor(private httpClient : HttpClient,
         private storage: StorageService,
          handler: HttpBackend,
           private authenticationService: AuthenticationService, private router: Router ) { 
        this.http = new HttpClient(handler);
    }
  
    login(loginRequestModel: ValidateUserWithPasswordRequestModel){

       return this.authenticationService.login(loginRequestModel);
            
    }

validateUserWithPersonalInfomation(userInformationRequestModel :ValidateUserWithPersonalInformationRequestModel){
    return this.http.post<ValidateUserResponseModel>(environment.server_url+"/api/ValidateUserWithPersonalInformation", userInformationRequestModel);
}

validateUserFirstTimeLogin(token :string, userSessionId:number){
    this.storage.setSessionData({ "userSessionId" : userSessionId, "token": token });
}
    
getRequiredUserInformation(userId : number){
    const params = new HttpParams().set('userID', userId.toString());
    return this.httpClient.get<RequiredInformationModel>(environment.server_url+"/api/RequiredUserInformation", {params});
}

logoutUser(){
    let logoutUserRequestModel= new LogoutUserRequestModel();
    logoutUserRequestModel.sessionID=this.storage.getSessionData().userSessionId;
   return this.httpClient.post<LogoutUserResponseModel>(environment.server_url+"/api/LogoutUser", logoutUserRequestModel)
    
}

}


// WEBPACK FOOTER //
// ./src/app/login/login/login.service.ts